import i18n from '../i18n';

export interface ViewModes {
  object: boolean;
  measurement: boolean;
  render: boolean;
  realTimeRender: boolean;
}

export type MeasurementVisualizationType =
  | 'tamanScore'
  | 'luminance'
  | 'horizontalIlluminance'
  | 'verticalIlluminance'
  | 'semiCylindricalIlluminance'
  | 'hemisphericalIlluminance';

export const MEASUREMENT_VISUALIZATION_LABELS: Record<MeasurementVisualizationType, string> = {
  get tamanScore() {
    return i18n.t('measurement.tamanScore');
  },
  get luminance() {
    return i18n.t('measurement.luminance');
  },
  get horizontalIlluminance() {
    return i18n.t('measurement.horizontalIlluminance');
  },
  get verticalIlluminance() {
    return i18n.t('measurement.verticalIlluminance');
  },
  get semiCylindricalIlluminance() {
    return i18n.t('measurement.semiCylindricalIlluminance');
  },
  get hemisphericalIlluminance() {
    return i18n.t('measurement.hemisphericalIlluminance');
  },
};

// Maps visualization type to the measurement field key
export const MEASUREMENT_VISUALIZATION_FIELD_MAP: Record<
  MeasurementVisualizationType,
  keyof { L: number; E: number; Ev: number; Esc: number; Ehs: number } | null
> = {
  tamanScore: null, // Taman score uses the first available value with deviation from expected
  luminance: 'L',
  horizontalIlluminance: 'E',
  verticalIlluminance: 'Ev',
  semiCylindricalIlluminance: 'Esc',
  hemisphericalIlluminance: 'Ehs',
};
